<template>
    <div>
        <r-button @click="showModal">Reset Password</r-button>
        <v-modal title="Reset Password" v-if="isModalVisible" @close="closeModal">
            <div slot="content">
                <v-error-messages
                    :has-frontend-errors="$v.$error"
                    :server-error="serverError"
                    class="stack-l">
                    <li class="list-item" v-if="!$v.pwd.currentPassword.required">Current password is required.</li>
                    <li class="list-item" v-if="!$v.pwd.newPassword.required">New password is required.</li>
                    <li class="list-item" v-if="!$v.pwd.newPassword.minLength">
                        New password must contain at least {{$v.pwd.newPassword.$params.minLength.min}} characters.</li>
                    <li class="list-item" v-if="!$v.pwd.newPassword.mustContainOneNumber">
                        New password must contain at least 1 digit.</li>
                    <li class="list-item" v-if="!serverError && !$v.pwd.newPassword.mustContainLowerCase">
                        New password must contain at least 1 lowercase letter.</li>
                    <li class="list-item" v-if="!$v.pwd.confirmPassword.required">Confirmation password is required.</li>
                    <li class="list-item" v-if="!$v.pwd.confirmPassword.minLength">
                        Confirmation password must contain at least {{$v.pwd.confirmPassword.$params.minLength.min}} characters.</li>
                    <li class="list-item" v-if="!$v.pwd.confirmPassword.sameAsPassword">
                        Confirmation password doesn't match your new password.</li>
                </v-error-messages>
                <p class="stack-m">Password must be at least {{$v.pwd.newPassword.$params.minLength.min}} characters long
                    and contain at least 1 lowercase letter and 1 digit.</p>
                <div class="grid-content">
                    <div class="grid-item grid-item-full">
                        <r-input
                            class="stack-m"
                            label="Current Password"
                            password
                            v-model="pwd.currentPassword"
                            :validate="$v.pwd.currentPassword"/>
                        <r-input
                            class="stack-m"
                            label="New Password"
                            password
                            v-model="pwd.newPassword"
                            :validate="$v.pwd.newPassword"/>
                        <r-input
                            class="stack-m"
                            label="Confirm Password"
                            password
                            v-model="pwd.confirmPassword"
                            :validate="$v.pwd.confirmPassword"/>
                    </div>
                </div>
            </div>
            <template slot="actions">
                <r-button type="primary" :disabled="isLoading || $v.$anyError" @click="resetPassword">reset password</r-button>
            </template>
        </v-modal>
    </div>
</template>
<script>
    import vModal from '@/components/modal/v-modal';
    import VErrorMessages from '@/components/form/v-error-messages';
    import FormLoaderMixin from '@/mixins/form-loader-mixin';
    import {minLength, required, sameAs} from 'vuelidate/lib/validators';

    const PASSWORD_MIN_LENGTH = 8;

    export default {
        name: 'reset-password-modal',
        mixins: [
            FormLoaderMixin,
        ],
        components: {
            VErrorMessages,
            vModal,
        },
        data() {
            return {
                isModalVisible: false,
                pwd: {
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: '',
                },
            };
        },
        validations: {
            pwd: {
                currentPassword: {
                    required,
                    minLength: minLength(PASSWORD_MIN_LENGTH),
                },
                newPassword: {
                    required,
                    minLength: minLength(PASSWORD_MIN_LENGTH),
                    mustContainOneNumber(pwd) {
                        return /\d/.test(pwd);
                    },
                    mustContainLowerCase(pwd) {
                        return /[a-z]/.test(pwd);
                    },
                },
                confirmPassword: {
                    required,
                    minLength: minLength(PASSWORD_MIN_LENGTH),
                    sameAsPassword: sameAs('newPassword'),
                },
            },
        },
        methods: {
            closeModal() {
                this.isModalVisible = false;
            },
            showModal() {
                this.$v.$reset();
                this.pwd.currentPassword = '';
                this.pwd.newPassword = '';
                this.pwd.confirmPassword = '';
                this.isModalVisible = true;
            },
            async resetPassword() {
                this.$v.$touch();
                if (!this.$v.pwd.$error) {
                    this.$emit('input', this.pwd);
                    this.closeModal();
                }
            },
        },
    };
</script>
